export const CIFSectionTitles = {
  clientDetails: {
    number: "2",
    title: "Client Details",
    description: "",
  },
  businessMarketSector: {
    number: "3",
    title: "Business Market Sector",
    description: "",
  },
  siteAddress: {
    number: "4",
    title: "Site Address",
    description: "",
  },
  companyContactDetails: {
    number: "5",
    title: "Company Contact Details",
    description: "",
  },
  serviceDetails: {
    number: "6",
    title: "Service Details",
    description: "",
  },
  accountTerms: {
    number: "7",
    title: "Account Terms",
    description:
      "Monthly Reoccurring Cost (MRC), UC8 will issue an electronic invoice which will be sent to your nominated email address. <br></br>Invoice are issued on the 1st day of each month but may vary from time to time.",
  },
  billingDetails: {
    number: "8",
    title: "Billing Details / Accounts Person",
    description: "",
  },
  primaryContactPerson: {
    number: "9",
    title: "Primary Contact Person / Owner / Director",
    description: "",
  },
  proofOfIdentity: {
    number: "10",
    title: "Proof of Identity",
    description:
      "To satisfy 100 points of identification, please attach a copy of your drivers license (front and back) or Passport. If you do not have either of these, please provide another form of photo ID and a copy of your most recent bill from the list below.",
  },
  personalGuarantee: {
    number: "11",
    title: "Personal / Director Guarantee and Indemnity",
    description:
      "I/WE (also referred to as the “Guarantor/s”) UNCONDITIONALLY AND IRREVOCABLY",
  },
  declaration: {
    number: "12",
    title: "Declaration / Guarantor",
    description:
      "I certify that the above information is true and correct and that I accept the supply of credit by the Seller (if applicable). I have read and understand the TERMS AND CONDITIONS OF TRADE (overleaf or attached) of UC8 Australia Pty Ltd which form part of, and are intended to be read in conjunction with this Application and Client Information Form and agree to be bound by these conditions. I authorise the use of my personal information as detailed in the Privacy Act clause therein. I agree that if I am a director/shareholder (owning at least 15% of the shares) of the Client I shall be personally liable for the performance of the Client’s obligations under this contract. I am an authorised person of the company or entity and I am authorised to enter into this agreement.",
  },
};
export const VAFSectionTitles = {
  customerDetails: {
    number: "2",
    title: "Customer Details",
    description: "",
  },
  siteAddress: {
    number: "3",
    title: "Site Address",
    description: "",
  },
  primaryContactPerson: {
    number: "4",
    title: "Primary Contact Person",
    description: "",
  },
  contactDetails: {
    number: "5",
    title: "Contact Details",
    description: "",
  },
  automaticFailover: {
    number: "6",
    title: "Automatic Failover & Service Redirection",
    description:
      "You can nominate a default number for automatic redirection of calls if your phone system or VoIP number fails to register on the UC8 network through a power or Internet outage, equipment failure, theft, damage or for any other reason. You can also request a manual redirection of service to a nominated number which is not listed below. The cost of redirected calls will be billed to your account (see plan details for charges).",
  },
  mobileNumber: {
    number: "7",
    title: "Mobile Numbers",
    description:
      "Please list your mobile telephone numbers below that you want to transfer to UC8.",
  },
  serviceDetails: {
    number: "8",
    title: "Service Details",
    description: "Please specify service details",
  },
  VOIP: {
    number: "9",
    title: "VoIP Provisioning Details",
    description:
      "You can port your current FNN (Full National Number/s) to UC8’s network or we can allocate new numbers. You will need an active Internet connection and compatible hardware for the service to work. UC8 recommends a dedicated Internet service to ensure call quality.",
  },
  directInDial: {
    number: "10",
    title: "Direct In Dial (DID) Number Range",
    description:
      "This feature allows calls to be received on individual handsets",
  },
  planAndService: {
    number: "11",
    title: "Plan and Service Details",
    description: "",
  },
  contactPeriod: {
    number: "12",
    title: "Contract Period",
    description: "",
  },
  proofOfIdentity: {
    number: "13",
    title: "Proof of Identity",
    description: "",
  },
  termsAndConditions: {
    number: "14",
    title:
      "Terms & Conditions | Preselect / Override / Geographical / VoIP / SIP / PSTN / Mobile Phone",
    description: "",
  },
  declaration: {
    number: "15",
    title: "Declaration",
    description:
      "I understand that by contracting with UC8 for my telephone number/s above, international, local, national long distance and calls to mobiles will be carried by UC8 after it accepts and processes this application. I also give UC8 consent to use any credit information about me, including information about my personal or company history. I have read the terms and conditions applicable to this application and agree to be bound by them. I have the authority to sign and certify that these details are true and correct.",
  },
};
export const APASectionTitles = {
  cardType: {
    number: "2",
    title: "",
    description: "",
  },
  directDebitFromBankAccount: {
    number: "3",
    title: "For direct debt from a bank account.",
    description: "",
  },
  declaration: {
    number: "4",
    title: "Declaration",
    description:
      "I request UC8 to debit my credit card or bank account as specified above. I confirm that I have read and understood the terms and conditions and accept this authority only upon those conditions.",
  },
  termsAndConditions: {
    number: "5",
    title: "Terms and Conditions.",
    description: "",
  },
};
export const PAFSectionTitles = {
  customerDetails: {
    number: "2",
    title: "Customer Details",
    description: "",
  },
  siteAddress: {
    number: "3",
    title: "Site Address",
    description: "",
  },
  contactPerson: {
    number: "4",
    title: "Contact Person",
    description: "",
  },
  contactDetails: {
    number: "5",
    title: "Contact Details",
    description: "",
  },
  portingFee: {
    number: "6",
    title: "Porting Fee",
    description: "You may port your current active telephone number/s from your current carriage service provider to UC8. A one off porting will apply. This fee will be charged to your UC8 account upon the successful transfer.",
  },
  portingNumbers: {
    number: "7",
    title: "Porting Numbers",
    description: "List your telephone number/s and corresponding service providers account numbers that you would like to port to UC8.",
  },
  listCurrentCarrier: {
    number: "8",
    title: "List Current Carrier or Carriage Service Provider",
    description: "",
  },
  proofLocationIdentity: {
    number: "9",
    title: "Proof of Location & Identity",
    description: "",
  },
  portingTermsConditions: {
    number: "10",
    title: "Porting Terms & Conditions",
    description: "",
  },
  numberPorting: {
    number: "11",
    title: "Declaration - Number Porting",
    description: "",
  },
};
